import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { DeskOperatorProvider } from '@lemontaigu/platform-ui';
import { createSupabaseDeskOperatorStore } from '@lemontaigu/platform/adapters/client';
import { ADMIN_API_BASE } from './config.js';
import { deskOperatorSession, supabase } from './supabase.js';

/**
 * The desk operator's composition root (DESK-OPERATOR-AND-MAIL-BRIEF §2, ADR-0026):
 * this app's client, the tab's session holder (the one its `fetch` reads), and the
 * site project's identify Function.
 */
export function AppDeskOperatorProvider({ children }: { children: ReactNode }) {
  const store = useMemo(
    () => createSupabaseDeskOperatorStore(supabase, deskOperatorSession, `${ADMIN_API_BASE}/api/desk/identify`),
    [],
  );
  return <DeskOperatorProvider store={store}>{children}</DeskOperatorProvider>;
}
